/**
 * Cleanup utility for corrupted localStorage entries
 */
export function cleanupCorruptedLocalStorage() {
  const keysToCheck = [
    'blocksystem-blocks',
    'blocksystem-connections',
    'blocksystem-connectionmarkers',
    'blocksystem-systems',
    'blocksystem-projectname',
    'blocksystem-viewstate',
    'blocksystem-backgroundsettings',
    'blocksystem-viewdisplaysettings',
    'blocksystem-showdimensions',
    'blocksystem-snapenabled',
    'blocksystem-pipetypes',
    'blocksystem-textannotations',
    'blocksystem-labeltemplates',
    'blocksystem-placedlabels',
    'blocksystem-selectedpipetype',
    'blocksystem-drawingfolder',
    'blocksystem-activedrawingid',
  ];

  let cleanedCount = 0;

  keysToCheck.forEach(key => {
    try {
      const value = localStorage.getItem(key);
      if (value !== null) {
        // Try to parse - if it fails, the data is corrupted
        JSON.parse(value);
      }
    } catch (error) {
      console.warn(`🗑️ Removing corrupted localStorage entry: ${key}`);
      try {
        localStorage.removeItem(key);
        cleanedCount++;
      } catch (removeError) {
        console.error(`Failed to remove ${key}:`, removeError);
      }
    }
  });

  if (cleanedCount > 0) {
    console.log(`✅ Cleaned ${cleanedCount} corrupted localStorage entries`);
  }

  return cleanedCount;
}
